import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import { Link } from '@zola/zola-ui';
import EntityHeader from '../EntityHeaderV2';
import RsvpsList from './RsvpsList';

// Actions
import { showModal } from '../../../../../actions/ModalActions';
import { togglePage } from '../../../../../actions/website/PageActions';
import { moveEntity } from '../../../../../actions/website/EntityActions';
import { editEvent } from '../../../../../actions/website/entities/RsvpActions';

const RsvpEdit = ({
  page,
  isPageHidden,
  themeKey,
  orderedIds,
  rsvpEntities,
  openEventFormModal,
  showSuccessModal,
  onPageToggle,
  isGotItTooltip,
  closeGotItTooltip,
  onSortEnd,
  onEdit,
}) => {

  const handlePageToggle = (pageId) => {
    onPageToggle(pageId);
    if (isPageHidden) showSuccessModal();
  };

  const GotItTooltip = (closeTooltip) => (
    <div className="got-it-tooltip">
      <div className="got-it-tooltip__text">Make this page visible to let guests RSVP on your website.</div>
      <Link className="got-it-tooltip__btn" role="button" onClick={closeTooltip}>Got it!</Link>
    </div>
  );

  return (
    <div>
      <EntityHeader
        page={page}
        themeKey={themeKey}
        onAdd={openEventFormModal}
        onPageToggle={handlePageToggle}
        entityName="Event"
        isGotItTooltip={isGotItTooltip}
        closeGotItTooltip={closeGotItTooltip}
        gotItTooltip={GotItTooltip(closeGotItTooltip)}
      />
      {rsvpEntities && (
        <RsvpsList
          rsvpEntities={rsvpEntities}
          orderedIds={orderedIds}
          onSortEnd={onSortEnd}
          onEdit={onEdit}
          useDragHandle
          lockAxis="y"
        />
      )}
    </div>
  );
}

const mapDispatchToProps = dispatch => ({
  onPageToggle: pageId => dispatch(togglePage(pageId)),
  showSuccessModal: () => dispatch(showModal('PUBLISH_RSVP', {}, { size: 'md' })),
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
  onEdit: (rsvp) => {
    dispatch(editEvent(rsvp));
    dispatch(showModal('EVENT_FORM', { websiteEvent: true, formIdentifier: 'eventForm' }, { size: 'md' }));
  },
});

RsvpEdit.propTypes = {
  page: PropTypes.shape({}),
  isPageHidden: PropTypes.bool,
  theme: PropTypes.shape({ key: PropTypes.string, font_name: PropTypes.string }),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  rsvpEntities: PropTypes.shape({}),
  openEventFormModal: PropTypes.func,
  showSuccessModal: PropTypes.func,
  onPageToggle: PropTypes.func,
  isGotItTooltip: PropTypes.bool,
  closeGotItTooltip: PropTypes.func,
  onSortEnd: PropTypes.func,
  onEdit: PropTypes.func,
};

export default connect(
  null,
  mapDispatchToProps,
)(RsvpEdit);



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Rsvp/RsvpEdit.jsx